const insertionOrderColumns = [
  {
    title: '',
    sort: { able: false },
  },
  {
    title: '',
    sort: { able: false },
  },
  {
    title: '期間',
    sort: { able: false },
  },
  {
    title: '予算',
    sort: { able: true, value: 'cpLifetimeBudget' },
  },
  {
    title: '消化金額',
    sort: { able: true, value: 'revenueBuyingCurrency' },
  },
  {
    title: 'インプレッション',
    sort: { able: true, value: 'imps' },
  },
  {
    title: 'クリック',
    sort: { able: true, value: 'clicks' },
  },
  {
    title: 'CTR',
    sort: { able: true, value: 'ctr' },
  },
  {
    title: 'CPC',
    sort: { able: true, value: 'cpc' },
  },
  {
    title: 'CPM',
    sort: { able: true, value: 'cpm' },
  },
  {
    title: '再生完了数',
    sort: { able: true, value: 'videoCompletions' },
  },
]

const campaignColumns = [
  {
    title: '',
    sort: { able: false },
  },
  {
    title: '',
    sort: { able: false },
  },
  {
    title: '期間',
    sort: { able: false },
  },
  {
    title: '予算',
    sort: { able: true, value: 'cpLifetimeBudget' },
  },
  {
    title: '消化金額',
    sort: { able: true, value: 'revenueBuyingCurrency' },
  },
  {
    title: 'インプレッション',
    sort: { able: true, value: 'imps' },
  },
  {
    title: 'クリック',
    sort: { able: true, value: 'clicks' },
  },
  {
    title: 'CTR',
    sort: { able: true, value: 'ctr' },
  },
  {
    title: 'CPC',
    sort: { able: true, value: 'cpc' },
  },
  {
    title: 'CPM',
    sort: { able: true, value: 'cpm' },
  },
  {
    title: '再生完了数',
    sort: { able: true, value: 'videoCompletions' },
  },
]

const deliveryGroupColumns = [
  {
    title: '',
    sort: { able: false },
  },
  {
    title: '配信グループ名',
    sort: { able: true, value: 'deliveryGroupName' },
  },
  {
    title: '期間',
    sort: { able: false },
  },
  {
    title: '予算',
    sort: { able: false },
  },
  {
    title: '消化金額',
    sort: { able: true, value: 'revenueBuyingCurrency' },
  },
  {
    title: 'インプレッション',
    sort: { able: true, value: 'imps' },
  },
  {
    title: 'クリック',
    sort: { able: true, value: 'clicks' },
  },
  {
    title: 'CTR',
    sort: { able: true, value: 'ctr' },
  },
  {
    title: 'CPC',
    sort: { able: true, value: 'cpc' },
  },
  {
    title: 'CPM',
    sort: { able: true, value: 'cpm' },
  },
  {
    title: '再生完了数',
    sort: { able: true, value: 'videoCompletions' },
  },
]
const defaultSortDirection = insertionOrderColumns
  .filter(c => c.sort.value != null)
  .reduce((result, item) => {
    result[item.sort.value] = true
    return result
  }, {})

export {
  insertionOrderColumns,
  campaignColumns,
  deliveryGroupColumns,
  defaultSortDirection,
}
